const INITIAL_STATE = {
  data: {},
  errors: {},
  
}
const getStaxKeys = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_STAX_KEYS_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_STAX_KEYS_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
  
export default getStaxKeys;